import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { TranslateService } from '@ngx-translate/core';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'area_privada';
  readonly SESSION_IDIOMA = KeysEstaticas.SESSION_IDIOMA;
  constructor(
    private translate: TranslateService,
    private sessionService: SessionService,
  ) {}

  ngOnInit() {
    const idioma =
      sessionStorage.getItem(this.SESSION_IDIOMA) ||
      this.sessionService.getIdioma();
    const lang = idioma;
    this.translate.setDefaultLang(lang!);
    this.translate.use(lang!);
  }
}
